export { default } from '@relo/sports-components/es/AccordionIcon';
export * from '@relo/sports-components/es/AccordionIcon';
